/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ km: NonNullable<unknown> }} Ui_Studio_Pick_From_StartInputs */

const en_ui_studio_pick_from_start = /** @type {(inputs: Ui_Studio_Pick_From_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.km} km from start`)
};

const de_ui_studio_pick_from_start = /** @type {(inputs: Ui_Studio_Pick_From_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.km} km ab Start`)
};

/**
* | output |
* | --- |
* | "{km} km from start" |
*
* @param {Ui_Studio_Pick_From_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_pick_from_start = /** @type {((inputs: Ui_Studio_Pick_From_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Pick_From_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_pick_from_start(inputs)
	return de_ui_studio_pick_from_start(inputs)
});